import React, { Component } from "react";
import { connect } from "react-redux";
import style from "../../assets/css/modules/health-information/healthinformation.css";
import ShadowedContainer from "./../shared/containers/ShadowedContainer";
import Article from "./../shared/Article";
import Store from "./../../content/Store";
import TabNavWithHeader from "./../shared/navigation/TabNavWithHeader";
import TextInput from "./../shared/form/TextInput";
import Content from "../../content/Content";
import PredictiveSearch from "../shared/PredictiveSearch";
import HomeCard from "../../components/home/HomeCard";
import MemberHelper from "./../../helpers/MemberHelper";
import { dispatchHealthTerms } from "../../actions/healthInformation/healthInformationActions";
import { getHealthRecommendations } from "./../../services/HealthInformationService";
import HealthInformationSearchBox from "./HealthInformationSearchBox";
import healthUnlockedSrc from "../../assets/img/powered-by-healthunlocked.png";
import InfoBox from "../shared/InfoBox";
import Popup from "reactjs-popup";
import { ModalPopup } from "../shared/ModalPopup";

export const mapStateToHealthInformation = (state) => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;

  const healthInformation = state.healthInformationReducer;

  const loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const postCode =
    loggedInMember && loggedInMember.Address && loggedInMember.Address.PostCode;

  return {
    postCode,
    healthTerms: healthInformation && healthInformation.healthTerms
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchHealthTerms: () => dispatch(dispatchHealthTerms())
});
export class HealthInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postCode: this.props.postCode,
      searchTermValue: ""
    };
    this.onHealthTermChange = this.onHealthTermChange.bind(this);
    this.onBrowseHealthConditionClick = this.onBrowseHealthConditionClick.bind(
      this
    );
    this.onSearchTermChange = this.onSearchTermChange.bind(this);
    this.onDiscoverLinkClick = this.onDiscoverLinkClick.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.onPopupContinue = this.onPopupContinue.bind(this);
  }
  componentDidMount() {
    if (!this.props.healthTerms) {
      this.props.dispatchHealthTerms();
    }
  }

  onBrowseHealthConditionClick() {
    this.setState({
      healthRecommendations: null,
      searchHealthTerm: null,
      searchTermValue: ""
    });
  }

  onHealthTermChange = (value) => {
    if (value) {
      getHealthRecommendations(value, this.state.postCode).then((response) => {
        this.setState({
          healthRecommendations: response,
          searchHealthTerm: value
        });
      });
    }
  };

  onSearchTermChange = (event, { newValue }) => {
    this.setState({
      searchTermValue: newValue
    });
  };

  onDiscoverLinkClick(url) {
    this.setState({ isPopupOpen: true, popupUrl: url });
  }

  closePopup() {
    this.setState({ isPopupOpen: false, popupUrl: "" });
  }

  onPopupContinue() {
    window.open(this.state.popupUrl);
    this.closePopup();
  }

  render() {
    return (
      <div
        className={
          style.healthinformation + " " + style.background + " postLogin"
        }
      >
        <div className={style.navBackground} />
        <TabNavWithHeader
          heading={Store.HealthInformation.Heading}
          applyTabNavWithImageStyles={true}
        />

        <ShadowedContainer className={style.noOverflowContainer}>
          <div className="row">
            {this.state.searchHealthTerm ? (
              <React.Fragment>
                <div className={`col-lg-8 ${style.title}`}>
                  <Content name={Store.HealthInformation.SubHeading} />
                </div>
                <div className="col-lg-12">
                  <InfoBox
                    iconClass={"icon-functional-help"}
                    children={Store.HealthInformation.Disclaimer}
                    className={style.infoBoxOverride}
                  />
                </div>
              </React.Fragment>
            ) : (
              <div className={`col-lg-8 ${style.title}`}>
                <Article
                  header={Store.HealthInformation.SubHeading}
                  body={Store.HealthInformation.Description}
                />
              </div>
            )}
          </div>
          <div className="row mt-4">
            <div className="col-lg-4">
              <TextInput
                label={<Content name={Store.HealthInformation.PostcodeLabel} />}
                tooltipContent={
                  <Content name={Store.HealthInformation.PostcodeTooltip} />
                }
                tooltipStyle={style.postcodeTooltip}
                inputValue={this.state.postCode}
                onChange={(event) => {
                  this.setState({ postCode: event.target.value });
                }}
                gradientClass="primary"
              />
            </div>
            <div className="col-lg-8">
              <PredictiveSearch
                label={Store.HealthInformation.SearchLabel}
                onHealthTermSelected={this.onHealthTermChange}
                healthTerms={this.props.healthTerms}
                onChange={this.onSearchTermChange}
                value={this.state.searchTermValue}
              />
            </div>
            <div className="col-lg-12">
              {this.state.searchHealthTerm ? (
                <React.Fragment>
                  <div className={style.conditionRow}>
                    <h3>{this.state.searchHealthTerm}</h3>
                    <button
                      onClick={this.onBrowseHealthConditionClick}
                      className={style.browseLink + " btn-link"}
                    >
                      {Store.HealthInformation.BrowseLink}{" "}
                      <span className="ml-2">➔</span>
                    </button>
                  </div>
                </React.Fragment>
              ) : null}
              <div className="row">
                {this.state.healthRecommendations ? (
                  <React.Fragment>
                    {this.state.healthRecommendations.map(
                      (healthRecommendation, key) => (
                        <React.Fragment key={key}>
                          <HealthInformationSearchBox
                            onDiscoverLinkClicked={this.onDiscoverLinkClick}
                            healthRecommendation={healthRecommendation}
                          />
                        </React.Fragment>
                      )
                    )}

                    {this.state.isPopupOpen ? (
                      <Popup
                        open={this.state.isPopupOpen}
                        modal
                        closeOnDocumentClick
                        onClose={this.closePopup}
                      >
                        <ModalPopup
                          cancel={() => this.closePopup()}
                          continue={() => this.onPopupContinue()}
                          heading={Store.HealthInformation.PopupHeading}
                          description={Store.HealthInformation.PopupDescription}
                          backlink={Store.HealthInformation.PopupBackLinkLabel}
                        />
                      </Popup>
                    ) : null}
                  </React.Fragment>
                ) : null}
              </div>
            </div>

            <div className={"col-12 " + style.healthUnlockedLogo}>
              <img
                src={healthUnlockedSrc}
                alt="Powered by Health Unlocked"
                className="float-right"
              />
            </div>
          </div>
        </ShadowedContainer>
        <div className="container">
          <div className="row">
            <div
              className={"col-sm-12 col-lg-6 " + style.healthInformationCard}
            >
              <Content
                names={[
                  Store.HealthSupport.Cards.ContactUs.Heading,
                  Store.HealthSupport.Cards.ContactUs.Description,
                  Store.HealthSupport.Cards.ContactUs.LinkText,
                  Store.HealthSupport.Cards.ContactUs.LinkTo
                ]}
              >
                {(heading, description, linkText, linkTo) => (
                  <HomeCard
                    iclass="icon-functional-email"
                    Heading={heading}
                    Description={description}
                    LinkText={linkText}
                    LinkTo={linkTo}
                  />
                )}
              </Content>
            </div>
            <div className="col-sm-12 col-lg-6">
              <Content
                names={[
                  Store.HealthSupport.Cards.SpeakToTeam.Heading,
                  Store.HealthSupport.Cards.SpeakToTeam.Description
                ]}
              >
                {(heading, description) => (
                  <HomeCard
                    iclass="icon-functional-phone"
                    Heading={heading}
                    Description={description}
                  />
                )}
              </Content>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToHealthInformation,
  mapDispatchToProps
)(HealthInformation);
